import { useEffect, useRef } from 'react';
import { $convertFromMarkdownString } from '@lexical/markdown';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { SerializedEditorState } from 'lexical';

export const ValueUpdatePlugin = ({ value }: { value?: string | SerializedEditorState }) => {
  const [editor] = useLexicalComposerContext();
  const isInitialized = useRef(false);
  const previousValueRef = useRef<string | SerializedEditorState | undefined>(undefined);

  useEffect(() => {
    // Skip update if value hasn't changed from what we last set
    // This prevents the editor from losing focus when the value comes from the editor itself
    if (isInitialized.current) {
      // Compare current editor state with incoming value to avoid unnecessary updates
      const currentEditorState = JSON.stringify(editor.getEditorState().toJSON());
      const incomingValue = typeof value === 'string' ? value : JSON.stringify(value);

      // If the values are the same, don't update (prevents focus loss)
      if (currentEditorState === incomingValue) {
        return;
      }

      // Also skip if the previous value is the same (prevents re-applying the same value)
      const previousValue =
        typeof previousValueRef.current === 'string'
          ? previousValueRef.current
          : JSON.stringify(previousValueRef.current);
      if (previousValue === incomingValue) {
        return;
      }
    }

    if (typeof value === 'string') {
      try {
        const parsedValue = JSON.parse(value);
        if (parsedValue && typeof parsedValue === 'object') {
          const editorState = editor.parseEditorState(parsedValue);
          editor.setEditorState(editorState);
        } else {
          editor.update(() => {
            $convertFromMarkdownString(value);
          });
        }
      } catch (error) {
        editor.update(() => {
          $convertFromMarkdownString(value);
        });
      }
    } else if (typeof value === 'object' && value !== null) {
      const editorState = editor.parseEditorState(value);
      editor.setEditorState(editorState);
    }

    previousValueRef.current = value;
    isInitialized.current = true;
  }, [value, editor]);

  return null;
};

// import { useEffect } from 'react';
// import { $getRoot, SerializedEditorState } from 'lexical';
// import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
// import { CustomTextNode } from '../CustomNodes/CustomTextNode';
// import { $convertFromMarkdownString } from '@lexical/markdown';

// function migrateTextNodesToCustom(): void {
//   const root = $getRoot();
//   const traverse = (node: any): void => {
//     const children = node.getChildren();
//     children.forEach((child: any) => {
//       // Si es un nodo de texto (tipo "text") y no es instancia de CustomTextNode
//       if (child.getType() === 'text' && !(child instanceof CustomTextNode)) {
//         const textContent = child.getTextContent();
//         // Crear un nodo personalizado utilizando el método "create"
//         const customNode = CustomTextNode.create(textContent);
//         child.replace(customNode);
//       } else {
//         traverse(child);
//       }
//     });
//   };
//   traverse(root);
// }

// export const ValueUpdatePlugin = ({ value }: { value?: string | SerializedEditorState }) => {
//   const [editor] = useLexicalComposerContext();

//   useEffect(() => {
//     if (typeof value === 'string') {
//       try {
//         const parsedValue = JSON.parse(value);
//         if (parsedValue && typeof parsedValue === 'object') {
//           const editorState = editor.parseEditorState(parsedValue);
//           editor.setEditorState(editorState);
//         } else {
//           editor.update(() => {
//             $convertFromMarkdownString(value);
//           });
//         }
//       } catch (error) {
//         editor.update(() => {
//           $convertFromMarkdownString(value);
//         });
//       }
//     } else if (typeof value === 'object' && value !== null) {
//       const editorState = editor.parseEditorState(value);
//       editor.setEditorState(editorState);
//     }

//     // Migrar nodos de texto a CustomTextNode después de actualizar el estado
//     editor.update(() => {
//       migrateTextNodesToCustom();
//     });
//   }, [value, editor]);

//   return null;
// };
